import React, { useState } from "react";
import { Map, MapPin, Route, Settings, X, FileText } from "lucide-react";
import POIsTab from "./tabs/POIsTab";
import RoutesTab from "./tabs/RoutesTab";
import SettingsTab from "./tabs/SettingsTab";
import FilesTab from "./tabs/FilesTab";

const Sidebar = ({ map, pois, routes, onVisibilityChange, visibilityState, onClose, surveyData }) => {
  const [activeTab, setActiveTab] = useState("pois");

  return (
    <div className="w-1/4 bg-[#2A2B2E] border-l border-gray-700 flex flex-col h-full">
      

      <div className="flex-1 flex flex-col">
        {/* Custom Tabs Navigation */}
        <div className="grid grid-cols-5 p-1 m-1 bg-gray-700/50 rounded-lg">
         <button
            onClick={() => setActiveTab("files")}
            className={`flex items-center justify-center rounded-md py-1.5 ${
              activeTab === "files" ? "bg-gray-800 text-white" : "text-gray-400 hover:text-white hover:bg-gray-700"
            }`}
          >
            <FileText className="w-6 h-6 mr-1" />
           
          </button>
          
          <button
            onClick={() => setActiveTab("pois")}
            className={`flex items-center justify-center rounded-md py-1.5 ${
              activeTab === "pois" ? "bg-gray-800 text-white" : "text-gray-400 hover:text-white hover:bg-gray-700"
            }`}
          >
            <MapPin className="w-64 h-6 mr-1" />
           
          </button>
          <button
            onClick={() => setActiveTab("routes")}
            className={`flex items-center justify-center rounded-md py-1.5 ${
              activeTab === "routes" ? "bg-gray-800 text-white" : "text-gray-400 hover:text-white hover:bg-gray-700"
            }`}
          >
            <Route className="w-6 h-6 mr-1" />
               </button>
          <button
            onClick={() => setActiveTab("settings")}
            className={`flex items-center justify-center rounded-md py-1.5 ${
              activeTab === "settings" ? "bg-gray-800 text-white" : "text-gray-400 hover:text-white hover:bg-gray-700"
            }`}
          >
            <Settings className="w-6 h-6 mr-1" />
          
          </button>
          <button
            onClick={() => setActiveTab("files")}
            className={`flex items-center justify-center rounded-md py-1.5 ${
              activeTab === "files" ? "bg-gray-800 text-white" : "text-gray-400 hover:text-white hover:bg-gray-700"
            }`}
          >
            <FileText className="w-6 h-6 mr-1" />
         
          </button>
        </div>

        {/* Tab Content */}
        <div className="flex-1 overflow-y-auto p-2">
          {activeTab === "pois" && (
            <POIsTab pois={pois} map={map} visibilityState={visibilityState} onVisibilityChange={onVisibilityChange} />
          )}
          
          {activeTab === "routes" && (
            <RoutesTab routes={routes} map={map} visibilityState={visibilityState} onVisibilityChange={onVisibilityChange} />
          )}
          
          {activeTab === "settings" && (
            <SettingsTab visibilityState={visibilityState} onVisibilityChange={onVisibilityChange} />
          )}
          
          {activeTab === "files" && (
            <FilesTab surveyId={surveyData?.id} />
          )}
        </div>
      </div>
    </div>
  );
};


export default Sidebar